export default "__VITE_ASSET__Dfs3FLsE__"